/* eslint-disable no-redeclare */
import type {
  AdServer,
  CampaignPlacement,
  Placement,
  ProductType,
  SubProductType,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export interface BuildAdContextProps {
  searchMethod?: string;
  productFit?: string;
  adId?: string;
  category?: CampaignPlacement;
  placement?: string;
  impressionPosition?: number;
  groupId?: number;
  creativeId?: number;
  creativeTitle?: string;
  advertiserName?: string;
  campaignName?: string;
  productName?: string;
}

export interface AdContextData
  extends Record<string, string | number | undefined> {
  search_method: string;
  product_fit: string;
  ad_id?: string;
  category?: Lowercase<Placement>;
  placement?: string;
  impression_position?: number;
  group_id?: string;
  creative_id?: string;
  creative_title?: string;
  advertiser_name?: string;
  campaign_name?: string;
  product_name?: string;
}

export const TrackingAdServer = z.enum([
  'featured-ads',
  'media-alpha',
  'ad-butler',
]);
export type TrackingAdServer = z.infer<typeof TrackingAdServer>;

export const TrackingProductName = z.enum(['health', 'medicare']);
export type TrackingProductName = z.infer<typeof TrackingProductName>;

export const TrackingSubProductName = z.enum([
  'aca',
  'medicare-generic',
  'medicare-advantage',
  'medicare-supplement',
]);
export type TrackingSubProductName = z.infer<typeof TrackingSubProductName>;

export const TrackingAdPlacement = z.enum(['typ']);
export type TrackingAdPlacement = z.infer<typeof TrackingAdPlacement>;

export interface AdContextDataV2
  extends Record<string, string | number | undefined> {
  ad_server: TrackingAdServer;
  advertiser_creative_id: string;
  advertiser_creative_title: string;
  advertiser_name?: string;
  advertiser_campaign_name?: string;
  publisher_ad_id: string;
  publisher_product_name: TrackingProductName;
  publisher_sub_product_name: TrackingSubProductName;
  publisher_placement: TrackingAdPlacement;
  impression_position: number;
  search_method?: string;
  product_fit?: string;
  group_id?: string;
}

export interface BuildAdContextV2Props {
  adServer: AdServer;
  advertiser: {
    creativeId: number;
    creativeTitle: string;
    name?: string;
    campaignName?: string;
  };
  publisher: {
    adId: string;
    productType: ProductType;
    subProductType?: SubProductType;
    placement: string;
  };
  impressionPosition: number;
  searchMethod?: string;
  productFit?: string;
  groupId?: number;
}
